var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _rect3, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssessment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 20V4C3 3.44772 3.44772 3 4 3H16C16.5523 3 17 3.44772 17 4V20C17 20.5523 16.5523 21 16 21H4C3.44772 21 3 20.5523 3 20Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.5L5.98586 8.48586C5.99367 8.49367 6.00633 8.49367 6.01414 8.48586L7.5 7",
    stroke: "black",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.5L5.98586 11.4859C5.99367 11.4937 6.00633 11.4937 6.01414 11.4859L7.5 10",
    stroke: "black",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 13.5L5.98586 14.4859C5.99367 14.4937 6.00633 14.4937 6.01414 14.4859L7.5 13",
    stroke: "black",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 16.5L5.98586 17.4859C5.99367 17.4937 6.00633 17.4937 6.01414 17.4859L7.5 16",
    stroke: "black",
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 12,
    width: 1,
    height: 4,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1724 10.1708C19.3629 9.95308 19.6977 9.94193 19.9023 10.1465L20.4849 10.7291C20.6711 10.9152 20.681 11.2138 20.5077 11.4119L19.609 12.439L18.3177 11.1476L19.1724 10.1708ZM17.6577 11.9019L13.651 16.481L14.9425 17.7725L18.9491 13.1933L17.6577 11.9019ZM14.25 18.4942L13.022 17.2662C13.0075 17.3133 13 17.3627 13 17.4128V18.5375H14.0462C14.1172 18.5375 14.1866 18.5224 14.25 18.4942ZM20.6094 9.43935C19.9958 8.82579 18.9912 8.85924 18.4198 9.51225L12.3711 16.4251C12.1319 16.6985 12 17.0495 12 17.4128V18.9375C12 19.2689 12.2686 19.5375 12.6 19.5375H14.0462C14.4788 19.5375 14.8903 19.3508 15.1751 19.0253L21.2603 12.0704C21.7803 11.4761 21.7504 10.5804 21.192 10.022L20.6094 9.43935Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 7H14.5",
    stroke: "black",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10H14.5",
    stroke: "black",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13H13.5",
    stroke: "black",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 16H11.5",
    stroke: "black",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessment);
export default __webpack_public_path__ + "static/media/assessment.3337620e.svg";
export { ForwardRef as ReactComponent };